module.exports = __webpack_public_path__ + "static/stats@2x-a690649b8636ea59d4a7f18221957b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/stats@2x.jpg
// module id = 433
// module chunks = 3627797113349 20562973939449 33019919093843